import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { DropdownMenuActionViewItem } from 'vscode/vscode/vs/base/browser/ui/dropdown/dropdownActionViewItem';
import { SuggestController } from 'vscode/vscode/vs/editor/contrib/suggest/browser/suggestController';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { IContextMenuService } from 'vscode/vscode/vs/platform/contextview/browser/contextView.service';
import { MODIFIED_SETTING_TAG, EXTENSION_SETTING_TAG, FEATURE_SETTING_TAG, GENERAL_TAG_SETTING_TAG, LANGUAGE_SETTING_TAG, POLICY_SETTING_TAG } from 'vscode/vscode/vs/workbench/contrib/preferences/common/preferences';

const _moduleId = "vs/workbench/contrib/preferences/browser/settingsSearchMenu";
let SettingsSearchFilterDropdownMenuActionViewItem = class SettingsSearchFilterDropdownMenuActionViewItem extends DropdownMenuActionViewItem {
    constructor(action, options, actionRunner, searchWidget, contextMenuService) {
        super(action, { getActions: () => this.getActions() }, contextMenuService, {
            ...options,
            actionRunner,
            classNames: action.class,
            anchorAlignmentProvider: () => 1 ,
            menuAsChild: true
        });
        this.searchWidget = searchWidget;
        this.suggestController = SuggestController.get(this.searchWidget.inputWidget);
    }
    render(container) {
        super.render(container);
    }
    doSearchWidgetAction(queryToAppend, triggerSuggest) {
        this.searchWidget.setValue(this.searchWidget.getValue().trimEnd() + ' ' + queryToAppend);
        this.searchWidget.focus();
        if (triggerSuggest && this.suggestController) {
            this.suggestController.triggerSuggest();
        }
    }
    createAction(id, label, tooltip, queryToAppend, triggerSuggest) {
        return {
            id,
            label,
            tooltip,
            class: undefined,
            enabled: true,
            run: () => { this.doSearchWidgetAction(queryToAppend, triggerSuggest); }
        };
    }
    createToggleAction(id, label, tooltip, queryToAppend) {
        const splitCurrentQuery = this.searchWidget.getValue().split(' ');
        const queryContainsQueryToAppend = splitCurrentQuery.includes(queryToAppend);
        return {
            id,
            label,
            tooltip,
            class: undefined,
            enabled: true,
            checked: queryContainsQueryToAppend,
            run: () => {
                if (!queryContainsQueryToAppend) {
                    const trimmedCurrentQuery = this.searchWidget.getValue().trimEnd();
                    const newQuery = trimmedCurrentQuery ? trimmedCurrentQuery + ' ' + queryToAppend : queryToAppend;
                    this.searchWidget.setValue(newQuery);
                }
                else {
                    const queryWithRemovedTags = this.searchWidget.getValue().split(' ')
                        .filter(word => word !== queryToAppend).join(' ');
                    this.searchWidget.setValue(queryWithRemovedTags);
                }
                this.searchWidget.focus();
            }
        };
    }
    getActions() {
        return [
            this.createToggleAction('modifiedSettingsSearch', ( localizeWithPath(_moduleId, 0, "Modified")), ( localizeWithPath(_moduleId, 1, "Add or remove modified settings filter")), `@${MODIFIED_SETTING_TAG}`),
            this.createAction('extSettingsSearch', ( localizeWithPath(_moduleId, 2, "Extension ID...")), ( localizeWithPath(_moduleId, 3, "Add extension ID filter")), `@${EXTENSION_SETTING_TAG}`, true),
            this.createAction('featuresSettingsSearch', ( localizeWithPath(_moduleId, 4, "Feature...")), ( localizeWithPath(_moduleId, 5, "Add feature filter")), `@${FEATURE_SETTING_TAG}`, true),
            this.createAction('tagSettingsSearch', ( localizeWithPath(_moduleId, 6, "Tag...")), ( localizeWithPath(_moduleId, 7, "Add tag filter")), `@${GENERAL_TAG_SETTING_TAG}`, true),
            this.createAction('langSettingsSearch', ( localizeWithPath(_moduleId, 8, "Language...")), ( localizeWithPath(_moduleId, 9, "Add language ID filter")), `@${LANGUAGE_SETTING_TAG}`, true),
            this.createToggleAction('onlineSettingsSearch', ( localizeWithPath(_moduleId, 10, "Online services")), ( localizeWithPath(_moduleId, 11, "Show settings for online services")), '@tag:usesOnlineServices'),
            this.createToggleAction('policySettingsSearch', ( localizeWithPath(_moduleId, 12, "Policy services")), ( localizeWithPath(_moduleId, 13, "Show settings for policy services")), `@${POLICY_SETTING_TAG}`)
        ];
    }
};
SettingsSearchFilterDropdownMenuActionViewItem = ( (__decorate([
    ( (__param(4, IContextMenuService)))
], SettingsSearchFilterDropdownMenuActionViewItem)));

export { SettingsSearchFilterDropdownMenuActionViewItem };
